module.exports = __webpack_public_path__ + "static/img/partner-th.e91925b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-th.png
// module id = gTVX
// module chunks = 34